// Testimonial data for All Seasons
// Each review can belong to multiple categories: 'landscape', 'trees', 'snow', 'maintenance'

const testimonials = [
  {
    id: 1,
    name: "Brian Poster",
    title: "President",
    company: "Poster Construction",
    location: "Wood River Valley, ID",
    text: "Poster Construction has been doing business with All Seasons for over 20 years. However, the new management at All Seasons has proven to be a game changer. Matt Taylor and his staff have demonstrated to be the most responsive subcontractor we work with. They always show up for meetings and offer positive direction to any project. They are committed to the success of the project and in both aesthetics as well as budget. The installation crews are equally fantastic. They work around the challenges of a jobsite with a can-do attitude, and their work is among the finest I've seen. Overall, All Seasons is a terrific choice for your Wood River Valley needs.",
    service: "Commercial Landscaping & Maintenance",
    categories: ['landscape', 'maintenance'],
    source: "Direct"
  },
  {
    id: 2,
    name: "G. D.",
    location: "Triumph, ID",
    text: "After 2 different not-so-great landscape companies in the last few years, we've finally landed on the GOOD one! We hired All Seasons for our driveway snow-blowing while gone for the winter. They are honest, fair in pricing and did the job we needed while out-of-town. Great peace-of-mind. My husband came back into town mid-winter for something and saw first-hand the job they had done while we were gone. Chris is our point-of-contact and he's been great. Once back to town in Spring, we had them come do our sprinklers and weed & feed job. They've been outstanding. Glad to finally find a landscaping outfit that has worked out and done the jobs we hired them for. Thank you!",
    service: "Snow Removal & Maintenance",
    categories: ['snow', 'maintenance'],
    source: "Yelp"
  },
  {
    id: 3,
    name: "Myra F.",
    location: "Portland, OR",
    text: "We had a flood in March. The water came into our living room and ruined our carpet and pad. We called All Seasons Landscaping and they arrived within the first hour of this occurring, sandbagged the outside and diverted the water, so no more would come into our home. We highly recommend All Seasons!",
    service: "Emergency Response",
    categories: ['maintenance'],
    source: "Yelp"
  },
  {
    id: 4,
    name: "Todd Nasura",
    location: "Wood River Valley, ID",
    text: "Nice friendly people. Knowledge. Price assessment. Great price.",
    service: "General Service",
    categories: ['landscape', 'maintenance'],
    source: "Google"
  },
  {
    id: 5,
    name: "David Lawrence",
    location: "Wood River Valley, ID",
    text: "Great place has excellent employees with great attitudes when it snows they are up early plowing and salting local businesses making winter more manageable and safer.",
    service: "Commercial Snow Removal",
    categories: ['snow'],
    source: "Google"
  }
];

export default testimonials;
